module.exports = __webpack_public_path__ + "static/media/Fs5v6.4de58752.mp3";